import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FilterChoiceShape } from 'utils/shapes';

import ArenaFilter from 'components/arena/ArenaFilter';
import Arena from 'components/arena/Arena';
import { setChoices, loadFavourites, removeMediaFromProject, addMediaToProject } from 'ducks/arena';
import { gettext } from 'utils/text';

const mapDispatchToProps = (dispatch) => ({
    setChoices: (choices) => dispatch(setChoices(choices)),
    loadFavourites: () => dispatch(loadFavourites()),
});

export const makeAddAndRemoveFromProjectCallbackFactory = ({ projectId, user, isParticipant, projectIsActive }) => (
    item,
    { dispatch },
) => {
    const hasItemAccess = user && item.user && item.user.id && user.id === item.user.id;
    if (hasItemAccess && item.projects.indexOf(projectId) !== -1) {
        return {
            actionCallback: () => {
                dispatch(removeMediaFromProject({ item, projectId }));
            },
            actionLabel: gettext('Remove from project'),
        };
    } else if (isParticipant && hasItemAccess && projectIsActive) {
        return {
            actionCallback: () => {
                dispatch(addMediaToProject({ item, projectId }));
            },
            actionLabel: gettext('Add to project'),
        };
    } else {
        return {};
    }
};

@connect(null, mapDispatchToProps)
class ArenaPreconfiguredWrapper extends Component {
    static propTypes = {
        setChoices: PropTypes.func.isRequired,
        loadFavourites: PropTypes.func.isRequired,
        filterChoices: PropTypes.arrayOf(FilterChoiceShape.isRequired).isRequired,
        selectedFilterKey: PropTypes.string.isRequired,
        actionCallbackFactory: PropTypes.func,
        excludeItem: PropTypes.number,
    };

    static defaultProps = {
        actionCallbackFactory: null,
        excludeItem: null,
    };

    componentDidMount = () => {
        const { filterChoices, selectedFilterKey } = this.props;

        // Load favourites
        this.props.loadFavourites();

        // Set filter choices
        this.props.setChoices({ choices: filterChoices, filterKey: selectedFilterKey });
    };

    render() {
        const { actionCallbackFactory, excludeItem } = this.props;
        return (
            <div>
                <ArenaFilter setTitle={false} noFlex />
                <Arena actionCallbackFactory={actionCallbackFactory} excludeItem={excludeItem} />
            </div>
        );
    }
}

export default ArenaPreconfiguredWrapper;



// WEBPACK FOOTER //
// ./src/components/arena/ArenaPreconfiguredWrapper.js